import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SearchModal from './SearchModal';

const SearchInput = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleKeyPress = (event) => {
      const activeElement = document.activeElement;
      const isTypingContext =
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable ||
        activeElement.tagName === 'SELECT' ||
        activeElement.getAttribute('role') === 'textbox';

      if (event.key === '/' && !isTypingContext) {
        event.preventDefault();
        setIsOpen(true);
      } else if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <>
      <button
        type="button"
        className="topbar-search"
        onClick={() => setIsOpen(true)}
        title={t('search_placeholder', 'Search') + ' (/)'}
      >
        <i className="icon-search" />
        <span className="topbar-search-label">{t('search_placeholder', 'Search…')}</span>
        <kbd>/</kbd>
      </button>

      <SearchModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default SearchInput;
